import { call, put } from 'redux-saga/effects'
import api from './../../utils/api'
import actions from './actions'

const queryEmbeddedReport = reportName => call(api.embedReport, reportName)

function* fetchEmbeddedReport(action) {
  let report
  try {
    yield put({ type: actions.fetching, report })
    report = yield queryEmbeddedReport(action.reportName)
    yield put({ type: actions.fetchSucceeded, report })
  } catch (e) {
    yield put({ type: actions.fetchFailed, error: e })
  }
}

export default fetchEmbeddedReport



// WEBPACK FOOTER //
// ./src/store/report-viewer/saga.js